import { useState, useEffect } from 'react';
import { getAssetSignedUrl } from '../../services/helpers/sign.asset.url';

/**
 * Renders a private CDN image by signing its S3 key via the signAssets Lambda.
 * Accepts an S3 key (public/articles/...) or a full CDN URL (old records) —
 * any leading protocol+domain is stripped so only the key is signed.
 */
export const SignedImage = ({ imageKey, alt = '', className = '' }) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!imageKey) return;
    const key = String(imageKey).replace(/^https?:\/\/[^/]+\//, '');
    getAssetSignedUrl({ url: key })
      .then((url) => { if (!cancelled) setSrc(url); })
      .catch((err) => { console.error('components.commons.signed.image', err); });
    return () => { cancelled = true; };
  }, [imageKey]);

  if (!src) return <div className={`${className} bg-gray-100`} />;
  return <img src={src} alt={alt} className={className} />;
};
